// Reusable ordered checklist editor ({id, label} items). Used by the global
// Content CMS (closing / prep checklists) and the per-buyer Closing override.
import React from "react";
import { Plus, Trash2, ChevronUp, ChevronDown } from "lucide-react";

export function ChecklistEditor({ title, items, onChange, idPrefix = "item", testidPrefix = "checklist", addLabel = "Add task", headerRight = null }) {
  const update = (i, label) => onChange(items.map((it, j) => j === i ? { ...it, label } : it));
  const remove = (i) => onChange(items.filter((_, j) => j !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= items.length) return;
    const next = [...items]; [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const add = () => onChange([...items, { id: `${idPrefix}${Date.now()}`, label: "New task" }]);

  return (
    <div className="card" style={{ padding: 28 }} data-testid={`${testidPrefix}-editor`}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
        <h3 className="font-serif" style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>{title}</h3>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {headerRight}
          <button type="button" className="btn-secondary" onClick={add} data-testid={`${testidPrefix}-add`}><Plus size={14} /> {addLabel}</button>
        </div>
      </div>
      <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 8 }}>
        {items.length === 0 ? (
          <div style={{ color: "var(--text-muted)", fontSize: 14 }}>No items — click "{addLabel}" to create one.</div>
        ) : items.map((it, i) => (
          <div key={it.id || i} style={{ display: "flex", gap: 6, alignItems: "center" }} data-testid={`${testidPrefix}-row-${i}`}>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <button type="button" className="btn-ghost" style={{ padding: 2 }} onClick={() => move(i, -1)} disabled={i === 0}><ChevronUp size={14} /></button>
              <button type="button" className="btn-ghost" style={{ padding: 2 }} onClick={() => move(i, +1)} disabled={i === items.length - 1}><ChevronDown size={14} /></button>
            </div>
            <input className="input-field" value={it.label} onChange={(e) => update(i, e.target.value)} data-testid={`${testidPrefix}-label-${i}`} />
            <button type="button" className="btn-ghost" onClick={() => remove(i)} data-testid={`${testidPrefix}-remove-${i}`}><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
